import watchGetIODataRequested from './getIODataSaga';
import watchGetFAQDataRequested from './getFAQDataSaga';
import watchWatchListToggleRequested from './watchListSaga';

export default [
  watchGetIODataRequested(),
  watchGetFAQDataRequested(),
  watchWatchListToggleRequested(),
];
